import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  boards: []
}

const HomeModule = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}

export default HomeModule
